export default __webpack_public_path__ + "static/media/people-icon.873bc3ae.svg";